import { render, staticRenderFns } from "./SendUserNotice.vue?vue&type=template&id=7fb38849"
import script from "./SendUserNotice.vue?vue&type=script&lang=js"
export * from "./SendUserNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports